import { Component, effect, input } from '@angular/core';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { TranslatePipe } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';

/**
 * when the row is clicked then tryUpdated is triggerd
 * when the value cell is clicked then cellClick is triggered and no tryUpdate is triggered
 */
export interface KeyValue {
  key: string;
  value: string;
  cellClick?: () => void;
  tryUpdate?: () => void;
  translateValue?: boolean;
  valuePrefix?: string;
}

@Component({
  selector: 'app-key-value-table',
  imports: [
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatRow,
    MatRowDef,
    MatTable,
    TranslatePipe,
    MatHeaderCellDef,
    MatIcon,
  ],
  templateUrl: './key-value-table.component.html',
  styleUrl: './key-value-table.component.scss',
})
export class KeyValueTableComponent {
  keyValues = input.required<KeyValue[]>();
  rows: KeyValue[] = [];

  constructor() {
    effect(() => {
      this.rows = this.keyValues();
    });
  }

  clickCell(event: Event, keyValue: KeyValue) {
    if (keyValue.cellClick !== undefined) {
      event.stopPropagation();
      keyValue.cellClick();
    }
  }
}
